import AdditionalFeeManagementTable from './AdditionalFeeManagementTable.vue';

export default AdditionalFeeManagementTable;
